import { render, staticRenderFns } from "./FilterIcon.vue?vue&type=template&id=47968a96&scoped=true&"
import script from "./FilterIcon.vue?vue&type=script&lang=js&"
export * from "./FilterIcon.vue?vue&type=script&lang=js&"
import style0 from "./FilterIcon.vue?vue&type=style&index=0&id=47968a96&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47968a96",
  null
  
)

export default component.exports